import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { UserService } from 'src/app/services/user.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';


@Component({
    selector: 'app-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RedirectComponent implements OnInit {
    constructor(
        private snackBar: MatSnackBar,
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private coreData: CoreData) { }

    ngOnInit(): void {

        // Already authenticated in another app
        this.route.queryParams.subscribe(async params => {

            if (!params['token']) {
                NotificationManager.handleWarning('', this.snackBar);
                return;
            }

            this.coreData.Token = params['token'];
            this.coreData.RefreshToken = params['rtoken'];
            // this.coreData.SelectedScopeCode = decodeURIComponent(params['selectedScope']);

            // Get the roles and permissions
            await new Promise((resolve, reject) => {
                this.userService.getRolePermissions().subscribe(x => {
                    this.coreData.RoleAndPermissions = x;
                    resolve(true);
                });
            });
            // redirect to your default page.
            this.router.navigate([ENavigationRoute.InterventionList]);
        });
    }
}
